// src/components/ui/ContainerComAbas.jsx
import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { motion } from "framer-motion";

export default function ContainerComAbas({
  children,
  tabs = [],
  activeTab,
  onTabChange,
  className = "",
}) {
  return (
    <Box
      className={`bg-white rounded-md shadow-md w-full h-full flex-1 overflow-hidden ${className}`}
      sx={{ minHeight: "100%" }}
    >
      {/* 🔹 Faixa com abas (fundo laranja) */}
      <Box
        sx={{
          width: "100%",
          bgcolor: "#1e1e1e",
          height: "70px",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          px: 3,
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => onTabChange(newValue)}
          textColor="inherit"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          TabIndicatorProps={{
            style: { backgroundColor: "transparent", height: "0px" },
          }}
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              label={
                activeTab === tab.id ? (
                  <motion.div
                    layoutId="activeTab"
                    transition={{ type: "spring", stiffness: 400, damping: 30 }}
                    style={{
                      borderRadius: "999px",
                      padding: "8px 20px",
                      backgroundColor: "#f95000", // fundo amarelo da aba ativa
                      color: "#fff", // texto branco da aba ativa ✅
                      fontSize: "14px",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      fontWeight: 500,
                      textTransform: "uppercase",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {tab.label}
                  </motion.div>
                ) : (
                  tab.label
                )
              }
              value={tab.id}
              sx={{
                fontSize: "14px",
                fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                fontWeight: 500,
                textTransform: "uppercase",
                marginRight: "40px",
                minHeight: "42px",
                padding: "8px 20px",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff", // texto branco nas abas inativas
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* 🔹 Conteúdo interno */}
      <Box className="px-5 py-4">{children}</Box>
    </Box>
  );
}
